// @ts-nocheck
import Swiper, { Navigation, Pagination } from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { encoder } from ".././services/encoder";

declare global {
    interface Window {

        CryptoJS: any; 
    }
}

export const page = async () => {
    console.log('userArea123')

    window.CryptoJS = new encoder();
    const swiper = new Swiper('.swiperuserArea', {
        modules: [Navigation, Pagination],
        slidesPerView: 1,
        spaceBetween: 30,
        pagination: {
            el: '.swiper-pagination',
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        breakpoints: {
            768: {
                slidesPerView: 2,
                spaceBetween: 30,
            },
            1024: {
                slidesPerView: 5,
                spaceBetween: 30,
                pagination: false,
            },
        },
    });
}